module.exports = __webpack_public_path__ + "static/img/prize3.60b1a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_activitycenter/prize3.png
// module id = b7AA
// module chunks = 1